var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sv-badge",class:`sv-badge--${_vm.alertKey}`,attrs:{"title":_vm.hoverMode ? null : _vm.tooltip,"aria-label":_vm.tooltip,"role":"img","data-test":`sv-badge-${_vm.alertKey}`},on:{"mouseenter":_vm.onEnter}},[_c('i',{staticClass:"fa",class:_vm.icon,attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }